import { createContext } from "react";

import {
  CLEAR_AUDITORY,
  LOGS_CONFIG,
  LOGS_UPDATE,
  SET_ERROR_LOGS,
  SET_ID_AUDITORY,
  SET_LOAD_AUDITORY,
  SET_STEP_LOGS,
  SET_SUCCESS_LOGS,
} from "../utils/constants";

export const initialState = {
  auditoria: {
    idAuditoria: "",
    tipoDocumento: "",
    numeroDocumento: "",
    idLead: "",
    correo: "",
    telefono: "",
    proteccionDatos: 1,
    comunicacionComercial: 0,
    codigoExterno: "",
    producto: "VIDA",
    placa: "",
    urlServicio: "",
    urlCliente: "",
    request: "",
    respuestaExito: "",
    respuestaError: "",
    codigoProducto: "VCD",
    origen: "",
    canal: "Portal Web",
    pasoInicialFinalizado: 0,
  },
  step: {
    paso: 0,
    pasoDescripcion: "PASO_INICIAL",
  },
  autoLoad: false,
  isLoading: false,
  logs: [],
};

export const auditoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR_LOGS: {
      return {
        ...state,
        logs: [
          ...state.logs,
          {
            paso: state.step.paso,
            pasoDescripcion: state.step.pasoDescripcion,
            urlServicio: action.servicios.urlServicio,
            urlCliente: action.servicios.urlCliente,
            respuestaError: action.servicios.respuestaError,
            request: action.servicios.request,
          },
        ],
      };
    }
    case SET_SUCCESS_LOGS: {
      return {
        ...state,
        logs: [
          ...state.logs,
          {
            paso: state.step.paso,
            pasoDescripcion: state.step.pasoDescripcion,
            urlServicio: action.servicios.urlServicio,
            urlCliente: action.servicios.urlCliente,
            respuestaExito: action.servicios.respuestaExito,
            request: action.servicios.request,
          },
        ],
      };
    }
    case SET_STEP_LOGS: {
      return {
        ...state,
        step: {
          paso: action.step.paso,
          pasoDescripcion: action.step.pasoDescripcion,
        },
      };
    }
    case LOGS_CONFIG: {
      const idAuditoria =
        state.auditoria.numeroDocumento !== action.auditoria.numeroDocumento &&
        action.auditoria.numeroDocumento !== "00000000" &&
        action.auditoria.tipoDocumento !== "04" &&
        state.auditoria.numeroDocumento !== "00000000" &&
        state.auditoria.tipoDocumento !== "04"
          ? ""
          : action.auditoria.idAuditoria || state.auditoria.idAuditoria;
      window.idAuditoria = idAuditoria;

      return {
        ...state,
        auditoria: {
          ...state.auditoria,
          tipoDocumento: action.auditoria.tipoDocumento,
          numeroDocumento: action.auditoria.numeroDocumento,
          correo: action.auditoria.correo,
          producto: action.auditoria.producto,
          codigoProducto: action.auditoria.codigoProducto,
          codigoExterno: String(action.auditoria.codigoExterno || ""),
          placa: action.auditoria.placa || "",
          idAuditoria,
          telefono: action.auditoria.telefono,
          idLead: action.auditoria.idLead || "",
          proteccionDatos: action.auditoria.proteccionDatos,
          comunicacionComercial: action.auditoria.comunicacionComercial,
          pasoInicialFinalizado: action.auditoria.pasoInicialFinalizado,
          origen: action.auditoria.origen || "",
          device: action.auditoria.device || "",
        },
      };
    }
    case SET_ID_AUDITORY: {
      return {
        ...state,
        auditoria: {
          ...state.auditoria,
          idAuditoria: action.idAuditoria,
          pasoInicialFinalizado: action.pasoInicialFinalizado,
        },
        isLoading: false,
      };
    }
    case SET_LOAD_AUDITORY: {
      return {
        ...state,
        isLoading: action.isLoading !== undefined ? action.isLoading : true,
      };
    }
    case LOGS_UPDATE: {
      return {
        ...state,
        logs: action.logs,
      };
    }
    case CLEAR_AUDITORY: {
      return initialState;
    }
    default:
      return state;
  }
};

export const AuditoryContext = createContext(initialState);

export const outAuditory = {
  dispatch: () => {},
  state: { ...initialState },
  selector: "",
};
